import { render, staticRenderFns } from "./TheFilterMainTyreTruck.vue?vue&type=template&id=4c901792&"
import script from "./TheFilterMainTyreTruck.vue?vue&type=script&lang=js&"
export * from "./TheFilterMainTyreTruck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports